export default __webpack_public_path__ + "static/article-how-to-budget-like-a-pro-0e251eac765313ffbf2c42192d3f344b.jpg";